var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatTeardropText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3126 16.875H3.72661C3.64733 16.8761 3.56863 16.8612 3.49517 16.8313C3.42171 16.8015 3.35498 16.7572 3.29891 16.7011C3.24283 16.6451 3.19856 16.5783 3.1687 16.5049C3.13884 16.4314 3.124 16.3527 3.12505 16.2734V9.6875C3.12505 7.78126 3.8823 5.95309 5.23022 4.60517C6.57814 3.25725 8.40631 2.5 10.3126 2.5V2.5C11.2564 2.5 12.1911 2.68591 13.0631 3.04712C13.9351 3.40832 14.7275 3.93775 15.3949 4.60517C16.0623 5.27259 16.5917 6.06493 16.9529 6.93696C17.3141 7.80899 17.5001 8.74362 17.5001 9.6875V9.6875C17.5001 10.6314 17.3141 11.566 16.9529 12.438C16.5917 13.3101 16.0623 14.1024 15.3949 14.7698C14.7275 15.4373 13.9351 15.9667 13.0631 16.3279C12.1911 16.6891 11.2564 16.875 10.3126 16.875V16.875Z",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 8.75H12.5",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 11.25H12.5",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardropText);
export default __webpack_public_path__ + "static/media/chat-teardrop-text.d25f486bfced8a6102eb8625811e578f.svg";
export { ForwardRef as ReactComponent };